<h2 class="text-tertiary d-flex justify-content-between uppercase">
  <span mat-dialog-title>{{
    multilingualService.langMap?.TITLE_PRESCRIPTION_DETAILS
  }}</span>
  <div class="d-flex">
    <button
      (click)="print()"
      class="mr-2 print"
      mat-icon-button
      [attr.aria-label]="multilingualService?.langMap?.LABEL_DOWNLOAD_PRESCRIPTION"
    >
      <mat-icon class="icon-print"></mat-icon>
    </button>

    <button
      mat-dialog-close
      (click)="close()"
      class="close"
      mat-icon-button
      [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
    >
      <mat-icon class="icon-cross"></mat-icon>
    </button>
  </div>
</h2>


<div
  role="status"
  aria-busy="true"
  class="center-loader center"
  *ngIf="isLoading"
>
  <img src="assets/images/loader.gif" alt="loader" width="60px" />
</div>

<mat-dialog-content class="mat-typography">
  <div class="view-detail">
    <div class="list-view d-flex">
      <div class="custom-block-width">
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_PATIENT_NAME}}</label>
            <p>{{ prescription.patientFirstName }}  {{ prescription.patientLastName }}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_PATIENT_DOB}}</label>
            <p>{{ prescription.patientDateOfBirth ? ( prescription.patientDateOfBirth | date: 'MM-dd-yyyy') : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_RX_NUMBER}}</label>
            <p>{{prescription.rxNumber ? prescription.rxNumber : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_PRESCRIBED_DRUG_NAME}}</label>
            <p>{{prescription.prescribedDrugName ? prescription.prescribedDrugName : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_DISPENSED_DRUG_NAME}}</label>
            <p>{{prescription.dispensedDrugName ? prescription.dispensedDrugName : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_DAW_LIST_OF_VALUES}}</label>
            <p>{{prescription.daw ? prescription.daw : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_DRUG_DEA_CLASS}}</label>
            <p>{{prescription.drugDeaClass ? prescription.drugDeaClass : ' - '}}</p>
          </div>
        </div>
      </div>
      <div class="custom-block-width">
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_QUANTITY}}</label>
            <p>{{prescription.quantity ? prescription.quantity : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_SUPPLY_DAYS}}</label>
            <p>{{prescription.daysSupply ? prescription.daysSupply : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_DISPENSED_DATE}}</label>
            <p>{{ prescription.dispensedDate ? ( prescription.dispensedDate  | date: 'MM-dd-yyyy' ) : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_PRESCRIBER_NAME}}</label>
            <p>{{prescription.prescriberFirstName}} {{prescription.prescriberLastName}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_DIRECTIONS}}</label>
            <p>{{prescription.directions ? prescription.directions : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_RX_DATE}}</label>
            <p>{{ prescription.rxDate  ? (prescription.rxDate  | date: 'MM-dd-yyyy') : ' - '}}</p>
          </div>
        </div>

        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_EXPIRATION_DATE}}</label>
            <p>{{prescription.expirationDate ? (prescription.expirationDate  | date: 'MM-dd-yyyy') : ' - '}}</p>
          </div>
        </div>
      </div>
      <div class="custom-block-width">
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_NUM_REFILLS}}</label>
            <p>{{prescription.numberOfRefillsAllowed ? prescription.numberOfRefillsAllowed : ' - '}}</p>
          </div>
        </div>

        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_REFILLS_REMAINING}}</label>
            <p>{{prescription.numberOfRefillsRemaining ? prescription.numberOfRefillsRemaining : ' - '}}</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_NXT_REFILL_DATE}}</label>
            <p>{{prescription.nextRefillDate ? (prescription.nextRefillDate | date: 'MM-dd-yyyy') : '-'}} &nbsp;</p>
          </div>
        </div>
        <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_FILLABLE_STATUS}}</label>
            <p>{{prescription.fillableStatus}}</p>
          </div>
        </div>
        <div class="information-block" *ngIf="prescription.specialtyIndicator">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_SPECIALTY_DRUG}}</label>
            <p>{{prescription.specialtyIndicator}}</p>
          </div>
        </div>
        <div class="information-block" *ngIf="prescription.autoRefillReminderAllowed">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_AUTO_REFILL_REMINDER}}</label>
            <p>{{prescription.autoRefillReminder}}</p>
          </div>
        </div>
        <div class="information-block" *ngIf="prescription.autoRefillChargeShipAllowed">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_AUTO_REFILL_CHARGE_SHIP}}</label>
            <p>{{prescription.autoRefillChargeShip}}</p>
          </div>
        </div>
        <!-- <div class="information-block">
          <div class="form-group">
            <label>NDC</label>
            <p>0101135</p>
          </div>
        </div> -->
        <!-- <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PHARMACY_NAME}}</label>
            <p>Costco</p>
          </div>
        </div> -->
        <!-- <div class="information-block">
          <div class="form-group">
            <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_NPI}} NPI</label>
            <p>1000000001</p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</mat-dialog-content>

<div *ngIf="isError" class="error-mesg mb-2 empty-box-height flex-column">
  <img
    aria-hidden="true"
    src="assets/images/wrong.svg"
    alt="Something went wrong"
    width="100px"
  />
  <p role="alert" class="title-10 text-w-700">{{ errMsg }}</p>
</div>
